export const CONTACT_START = 'CONTACT_START';
export const CONTACT_SUCCESS = 'CONTACT_SUCCESS';
export const CONTACT_FAIL = 'CONTACT_FAIL';
export const CONTACT_RESET = 'CONTACT_RESET';
